<template>
  <div class="invoice-header">
    <table class="invoice-header__table">
      <tbody>
      <tr>
        <td class="invoice-header__logo invoice-header__left">
          <img :src="require('@/assets/h4b_logo_big.png')" width="70%" alt="Hotel4box logo">
        </td>
        <td class="invoice-header__right">
          <div class="invoice-header__address invoice-header__address--highlight">
            {{ invoice.shipper.name }}
          </div>
          <div class="invoice-header__address">
            {{ invoice.shipper.street }}
          </div>
          <div class="invoice-header__address">
            {{ invoice.shipper.city }}
          </div>
          <div class="invoice-header__address">
            Tel: {{ invoice.shipper.phone }}
          </div>
        </td>
      </tr>
      <tr>
        <td class="invoice-header__left">
          <div class="invoice-header__address invoice-header__address--highlight">
            {{ invoice.order.recipient_name }}
          </div>
          <div class="invoice-header__address">
            {{ invoice.order.contact_number }}
          </div>
          <div class="invoice-header__address">
            {{ invoice.order.address }}
          </div>
          <div class="invoice-header__address" v-if="invoice.order.address_2 && invoice.order.address_2.length">
            {{ invoice.order.address_2 }}
          </div>
          <div class="invoice-header__address">
            {{ invoice.order.zipcode }}
          </div>
        </td>
        <td class="invoice-header__right invoice-header--spacing">
          <div class="invoice-header__address invoice-header__address--highlight">
            Invoice: {{ invoice.id | id }}
          </div>
          <div class="invoice-header__address">
            Order: {{ orderId | id }}
          </div>
          <div class="invoice-header__address">
            Description: {{ invoice.order.name }}
          </div>
          <div class="invoice-header__address">
            Date paid: {{ invoice.human_friendly_date_paid }}
          </div>
          <div class="invoice-header__address" v-if="countryOfOriginName">
            Country of Origin: {{ countryOfOriginName }}
          </div>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="invoice-header__title">
      <span v-if="invoice.type === $invoiceType.PayForBase">Merchandise Invoice</span>
      <span v-else-if="invoice.group">Consolidated Shipping Invoice</span>
      <span v-else-if="invoice.order && (invoice.order.order_id_before_returning)">Return Fee Invoice</span>
      <span v-else>Shipping Invoice</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'InvoiceViewHeader',
  props: {
    invoice: {
      type: Object,
      required: true
    }
  },
  computed: {
    orderId() {
      if (this.invoice.group) {
        return this.invoice.group.orders.map(order => order.id);
      } else {
        return this.invoice.order.id;
      }
    },
    countryOfOriginName() {
      if (this.invoice &&
          'order' in this.invoice &&
          this.invoice.order &&
          'country_of_origin' in this.invoice.order &&
          this.invoice.order.country_of_origin &&
          'name' in this.invoice.order.country_of_origin
      ) {
        return this.invoice.order.country_of_origin.name;
      }
      return '';
    }
  },
  filters: {
    id: function (id) {
      if (!id) return '';

      if (Array.isArray(id)) {
        return id.map(id => '#' + id.toString().padStart(6, '0')).join(' ')
      }
      return '#' + id.toString().padStart(6, '0');
    }
  },
}
</script>

<style scoped lang="stylus">

td
  background-color #fff
  border none
  padding 0

th
  background-color #fff
  border none

.invoice-header
  width 100%
  padding 0 0.5em

.invoice--width-print
  width 100%
  padding 1%

.invoice-header__table
  width 100%
  margin 1.5em 0

.invoice-header__left
  text-align left
  max-width 50%
  width 50%

.invoice-header__right
  text-align right
  max-width 50%
  width 50%

.invoice-header--spacing
  padding 2em 0

.invoice-header__logo
  vertical-align top

.invoice-header__address
  margin 0.5em 0

.invoice-header__address--highlight
  font-weight bold
  margin-bottom 1.5em

.invoice-header__title
  font-weight bold
  font-size 1.5em
  margin 0.5em 0
  padding-bottom 5px
  width 100%

</style>
